"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStrategyMatrixSearchParamsString = exports.decodeStrategyMatrixQueryState = exports.encodeStrategyMatrixQueryState = void 0;
const lz_string_1 = require("lz-string");
const strategy_matrix_query_params_models_1 = require("./strategy-matrix-query-params.models");
const strategy_matrix_query_params_normalizers_1 = require("./strategy-matrix-query-params.normalizers");
const strategy_matrix_query_params_parsers_1 = require("./strategy-matrix-query-params.parsers");
const view_query_params_1 = require("../../../common/view-query-params");
const encodeStrategyMatrixQueryState = (state, defaults) => {
    const normalizedState = (0, strategy_matrix_query_params_normalizers_1.normalizeStrategyMatrixQueryState)(state, defaults);
    if (!normalizedState)
        return undefined;
    return (0, lz_string_1.compressToEncodedURIComponent)(JSON.stringify(normalizedState));
};
exports.encodeStrategyMatrixQueryState = encodeStrategyMatrixQueryState;
const decodeStrategyMatrixQueryState = (encodedState) => {
    if (!encodedState)
        return null;
    try {
        const decompressedState = (0, lz_string_1.decompressFromEncodedURIComponent)(encodedState);
        if (!decompressedState)
            return null;
        return (0, strategy_matrix_query_params_parsers_1.parseStrategyMatrixQueryState)(JSON.parse(decompressedState));
    }
    catch (_a) {
        return null;
    }
};
exports.decodeStrategyMatrixQueryState = decodeStrategyMatrixQueryState;
const getStrategyMatrixSearchParamsString = ({ projectId, catalogId, viewState, }) => {
    const queryParams = new URLSearchParams();
    const encodedViewState = (0, exports.encodeStrategyMatrixQueryState)(Object.assign(Object.assign({}, viewState), { [strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.ProjectId]: projectId, [strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.CatalogId]: catalogId }));
    if (encodedViewState)
        queryParams.set(view_query_params_1.VIEW_QUERY_STATE_QUERY_KEY, encodedViewState);
    const serializedParams = queryParams.toString();
    return serializedParams ? `?${serializedParams}` : '';
};
exports.getStrategyMatrixSearchParamsString = getStrategyMatrixSearchParamsString;
